var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrrowLeft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.905 16.8527C12.4764 16.8527 12.0541 16.7123 11.7192 16.4404L7.07906 12.6715C6.70777 12.371 6.49483 11.9381 6.49483 11.4856C6.49483 11.033 6.70777 10.6002 7.07815 10.2996L11.7192 6.53164C12.2725 6.08087 13.0615 5.99054 13.7295 6.2991C14.3192 6.57278 14.685 7.11567 14.685 7.71758L14.685 15.2536C14.685 15.8555 14.3192 16.3984 13.7295 16.6721C13.4665 16.7937 13.1844 16.8527 12.905 16.8527Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2844_6958",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 9,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.905 16.8527C12.4764 16.8527 12.0541 16.7123 11.7192 16.4404L7.07906 12.6715C6.70777 12.371 6.49483 11.9381 6.49483 11.4856C6.49483 11.033 6.70777 10.6002 7.07815 10.2996L11.7192 6.53164C12.2725 6.08087 13.0615 5.99054 13.7295 6.2991C14.3192 6.57278 14.685 7.11567 14.685 7.71758L14.685 15.2536C14.685 15.8555 14.3192 16.3984 13.7295 16.6721C13.4665 16.7937 13.1844 16.8527 12.905 16.8527Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2844_6958)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.579803,
    y: 0.753052,
    width: 21.8404,
    height: 21.465,
    fill: "#0D1C2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrrowLeft);
export default __webpack_public_path__ + "static/media/arrrow-left.f1145b991bed5b32aa4c6eb240748702.svg";
export { ForwardRef as ReactComponent };